import React, { useState, useEffect, useRef } from "react";
import { readAttachmentList } from "../../helper/attachmentList.js";
import { logo } from "../../assets/svg/svg";
import { CompleteLoader, ReplyModal, FileReaderModel } from "../../modals/common-alert";
import Cookies from "universal-cookie";
import config from "../../web3/web3Config.json";
import moment from "moment-timezone";
import { markMessageAsImportant, web3AccountCheck, isEventExist, deleteEvent, updateEvent, encrypt } from "../../helper/web3helper";
import { convertToUtc, formatDateTime, getEventPrams, updateICS, getEmailContents } from "../../helper/commonHelper.js"
import { convertToLocalDate, optionalValidation, convertToLocalDateforWeb2, getFirstLetterUppercase } from "../../helper/object-validation-helper";
import { downloadFile, getFile, getFileIcon } from "../../helper/attachmentHelper";
import { Tooltip } from "antd";
import { useSelector } from "react-redux";
import { deleteEmails } from "../../helper/emailHelper.js";
import { updateInsecureMail, sendConfirmationEmail, updateBookingSlotStatus } from "../../service/api-actions.js";
import Swal from "sweetalert2";
import { toast, Bounce } from "react-toastify";
import { sendEmails } from '../../helper/emailHelper.js';
import '../../assets/css/calendar.css'
import { parseICalendar } from '../../helper/inviteHelper.js';
import { repharseYahooMessage } from '../../helper/eventHelper.js';
import { Button, Popover } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import { FileAudio2, FileVideo2 } from 'lucide-react';
import { transactionAction } from "../../helper/chain-helper.js";
import { getCalendarContract, getHostContract } from "../../helper/contract-helper.js";
import { reportError, toErrorString } from "../../utils/errorLogger.js";
import quotedPrintable from 'quoted-printable';
import DOMPurify from 'dompurify';
const cookies = new Cookies();

const Decrypt = (props) => {
    const { selectedMessage, decryptedContent, } = props;
    const filter = props.messageList.find(data => data.id === selectedMessage.id)
    const senderDetails = JSON.parse(selectedMessage?.header);
    const [replyModal, setReplyModal] = useState(false);
    const [messageType, setMessageType] = useState(null);
    const [disable, setDisable] = useState(false)
    const [web3Value, setWeb3] = useState(null);
    const [account, setAccount] = useState("");
    const [loader, setLoader] = useState(false);
    const [text, setText] = useState('')
    const [decryptFile, setDecryptFile] = useState(null);
    const [isOpenFileReader, setIsOpenFileReader] = useState(false);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [icons, setIcons] = useState({});
    const getFolderIndex = useSelector((state) => state.folderIndex);
    const [messageList, setMessageList] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const messageContainerRef = useRef(null);
    const [start, setStart] = useState();
    const [end, setEnd] = useState();
    const [fromstart, setFromStart] = useState();
    const [eventTimeZone, setEventTimeZone] = useState(null);
    const [toend, setToEnd] = useState();
    const [user] = useState(cookies.get("userObject"));
    const messageValue = JSON.parse(decryptedContent);
    /**
     * BOTH SHAPES, READ AT ONE PLACE.
     *
     * This used to be `messageValue.attachment || []`, which is this client's own key. A message
     * sent from the phone writes `attachments` (plural) instead, so its files were invisible here —
     * the message opened, the text rendered, and the attachment strip was simply absent.
     *
     * Everything below still receives `{ "<fileName>": "<path>" }` entries, so the render, the
     * preview, the icon lookup and the download handler are all unchanged. See helper/attachmentList.
     */
    const attachmentValue = readAttachmentList(messageValue);
    const [disabledButton, setDisabledButton] = useState(null);
    const [htmlContent, setHtmlContent] = useState('');
    const [isEventExistChain, setIsEventExist] = useState(true);
    const [organizer, setOrganizer] = useState(false);
    const [shouldShowMoreButton, setShouldShowMoreButton] = useState(false);
    const isStarred = optionalValidation(selectedMessage, "isStarred");
    const starSvg = filter?.isStarred ? logo.star_svg_fill : logo.star_svg_outline;
    const toOrFrom = props?.pageType === "Sent" ? "To :" : "From :";
    const token = cookies.get("accessToken") || localStorage.getItem("accessToken");
    const contractInstance = getCalendarContract();
    const toOrFromName =
        props.pageType === "Sent"
            ? JSON.parse(selectedMessage?.receiver).to[0]
            : selectedMessage.sender;
    const audioExtensions = ["mp3", "wav", "ogg", "flac"];
    const videoExtensions = ["mp4", "avi", "mkv"];
    const userName = localStorage.getItem('UserName');
    const handleButtonClick = (buttonIndex) => {
        setDisabledButton(buttonIndex);
    };
    const handleCloseModal = () => {
        setReplyModal(false)
    }
    const deleteevent = async (event) => {
        const params = await getEventPrams(event, 'cancel', start, end);
        setLoader(true)
        setText("Please wait, your event is being deleted, Going forward it will be fast.")
        const result = await deleteEvent(params?.uid, account, user.name.toString())
        if (result) {
            setDisable(true)
        }
        setLoader(false)
        setText("")
    }

    useEffect(() => {
        if (toOrFromName.split('@')[1] === 'yahoo.com' && messageValue.event && messageValue.message) {
            const rephareContent = repharseYahooMessage(messageValue.message, fromstart, toend)
            setHtmlContent(rephareContent);
        } else {
            let decodedMessage = messageValue.message;
            
            if (decodedMessage) {
                // Step 1: Decode quoted-printable encoding if present (for Gmail imports)
                if (decodedMessage.includes('=3D') || decodedMessage.includes('=\r\n') || decodedMessage.includes('=\n')) {
                    try {
                        decodedMessage = quotedPrintable.decode(decodedMessage);
                    } catch (error) {
                        console.warn('Failed to decode quoted-printable:', error);
                    }
                }
                
                // Step 2: Check if the content looks like escaped HTML (starts with &lt; or contains HTML entities)
                if (decodedMessage.includes('&lt;') || decodedMessage.includes('&gt;') || decodedMessage.includes('&quot;')) {
                    try {
                        const textarea = document.createElement('textarea');
                        textarea.innerHTML = decodedMessage;
                        decodedMessage = textarea.value;
                    } catch (error) {
                        console.warn('Failed to decode HTML entities:', error);
                    }
                }
                
                // Step 3: Remove wrapping <p> tags and <br/> tags added by backend
                if ((decodedMessage.startsWith('<p>') && decodedMessage.includes('<!DOCTYPE')) || decodedMessage.includes('<html')) {
                    try {
                        // Remove opening <p> tag
                        decodedMessage = decodedMessage.replace(/^<p>/i, '');
                        // Remove closing </p> tag
                        decodedMessage = decodedMessage.replace(/<\/p>$/i, '');
                        // Replace <br/> tags with actual line breaks
                        decodedMessage = decodedMessage.replace(/<br\s*\/?>/gi, '\n');
                    } catch (error) {
                        console.warn('Failed to unwrap HTML:', error);
                    }
                }
                
                // Step 4: Extract HTML content from multipart emails
                // This removes plain text headers that appear before the HTML content
                if (decodedMessage.includes('<!DOCTYPE') || decodedMessage.includes('<html')) {
                    try {
                        // Find the start of HTML content
                        const htmlStartPatterns = [
                            /<!DOCTYPE[^>]*>/i,
                            /<html[^>]*>/i,
                            /<HTML[^>]*>/i
                        ];
                        
                        let htmlStartIndex = -1;
                        for (const pattern of htmlStartPatterns) {
                            const match = decodedMessage.match(pattern);
                            if (match) {
                                htmlStartIndex = match.index;
                                break;
                            }
                        }
                        
                        // If we found HTML start, extract from there
                        if (htmlStartIndex > 0) {
                            decodedMessage = decodedMessage.substring(htmlStartIndex);
                        }
                        
                        // Find the end of HTML content
                        const htmlEndPatterns = [
                            /<\/html>/i,
                            /<\/HTML>/i
                        ];
                        
                        let htmlEndIndex = -1;
                        for (const pattern of htmlEndPatterns) {
                            const match = decodedMessage.match(pattern);
                            if (match) {
                                htmlEndIndex = match.index + match[0].length;
                                break;
                            }
                        }
                        
                        // If we found HTML end, extract up to there
                        if (htmlEndIndex > 0) {
                            decodedMessage = decodedMessage.substring(0, htmlEndIndex);
                        }
                    } catch (error) {
                        console.warn('Failed to extract HTML content:', error);
                    }
                }
                
                // Step 5: Clean up garbled characters (replacement characters from encoding issues)
                if (decodedMessage.includes('�')) {
                    try {
                        // Remove replacement characters and their surrounding context
                        decodedMessage = decodedMessage.replace(/[�\uFFFD]+/g, '');
                        // Clean up excessive whitespace that might be left behind
                        decodedMessage = decodedMessage.replace(/\n{3,}/g, '\n\n');
                    } catch (error) {
                        console.warn('Failed to clean garbled characters:', error);
                    }
                }
            }
            
            setHtmlContent(decodedMessage);
        }

    }, [messageValue])

    useEffect(() => {
        if (!messageValue.event) {
            return;
        }
        const getOrganizer = messageValue.event.event.ORGANIZER?.value?.split(":")[messageValue.event.event.ORGANIZER?.value?.split(":").length - 1] || null;
        if (getOrganizer) {
            const organizerEmailHost = getOrganizer.split('@')[1];
            let email = null;
            if (organizerEmailHost === config.VERFIED_DOMAIN) {
                email = getOrganizer.replace(organizerEmailHost, config.DOMAIN).replace(/\s/g, '');
            } else {
                email = getOrganizer;
            }
            if (user.name.toString() === email) {
                setOrganizer(true);
            }
        }
        const timezone = messageValue.event.timezones?.END?.TZID || 'Etc/UTC';
        setEventTimeZone(timezone);
        const startEvent = messageValue.event.event.DTSTART.value || messageValue.event.event.DTSTART;
        const endEvent = messageValue.event.event.DTEND.value || messageValue.event.event.DTEND;
        const startTime = convertToUtc(startEvent, timezone);
        const endTime = convertToUtc(endEvent, timezone);
        const startTimeComponents = formatDateTime(startTime);
        const endTimeComponents = formatDateTime(endTime);
        const formatTime = ({ year, month, date, hour, minute }) => `${year}${month}${date}T${hour}${minute}00`;
        const eventStarts = formatTime(startTimeComponents);
        const eventEnds = formatTime(endTimeComponents);
        setStart(eventStarts);
        setFromStart(convertToLocalFormat(startTime, startEvent));
        setEnd(eventEnds);
        setToEnd(convertToLocalFormat(endTime, startEvent));
        checkEvent();
    }, [messageValue.event])
    function convertToLocalFormat(startTime, time) {
        if (/^\d{1,8}$/.test(time)) {
            const utcTime = moment.utc(startTime);
            const istTime = utcTime.format('MMMM DD, YYYY [at] hh:mm:ss A');
            return istTime
        }
        else {
            const response = convertToLocalDate(startTime);
            return response
        }
    }
    const checkEvent = async () => {
        const uuid = messageValue.event.event.UID;
        if (uuid) {
            const getEvent = await isEventExist(user.name.toString(), uuid, account);
            if (getEvent?.length > 0) {
                setIsEventExist(true);
            } else {
                setIsEventExist(false);
            }
        }
    }

    const handleEventdata = async (acceptValue) => {
        try {
            let icsFile = null;
            let event = null;
            if (attachmentValue.length > 0) {
                for (const attachment of attachmentValue) {
                    const firstICSFile = Object.keys(attachment).find(file => file.endsWith('.ics'));
                    if (firstICSFile) {
                        const decryptedFile = await getFile(firstICSFile, attachment[firstICSFile]);
                        if (decryptedFile) {
                            const getICSfile = await updateICS(decryptedFile, user.name.toString(), acceptValue);
                            icsFile = getICSfile.file;
                            event = await parseICalendar(getICSfile.fileContent);
                        }
                        break;
                    }
                }
            }
            if (!icsFile) {
                toast.error("Failed to get ics file", {
                    position: "top-center",
                    transition: Bounce,
                });
                return;
            }
            let params;
            params = await getEventPrams(messageValue.event, acceptValue, start, end);

            if (acceptValue === 'no' && params?.appointmentEvent) {
                await updateBookingSlotStatus({
                    "appointmentBookingId": params?.uid,
                    "status": "cancelled",
                    "appointmentStatus": "declined"
                });
                toast.success("Event cancelled successfully", {
                    position: "top-center",
                    transition: Bounce,
                });
                return true;
            }

            const orgainzerValue = params.list.filter(data => data.key === "organizer")
            const orgainzerResponse = orgainzerValue && orgainzerValue[0]?.value?.split("@")[1]
            if (orgainzerResponse === "group.calendar.google.com") {
                params = {
                    ...params,
                    list: params.list.map(data => {
                        if (data.key === "organizer") {
                            return { key: "organizer", value: selectedMessage.sender.toString() }
                        }
                        return data;
                    })
                }
            }
            let repeatEvents = params.list.filter(data => data.key === "repeatEvent").map(data => data.value).filter(value => value !== null)
            let customRepeat = params.list.filter(data => data.key === "customRepeatEvent").map(data => data.value).filter(value => value !== null)
            let singleEvent = params.list.filter(data => data.key === "singleEvent").map(data => data.value).filter(value => value !== null)
            let isDuplicate = false;
            let existingEventId = null;

            let existingParentEvent = null
            if (isEventExistChain) {
                isDuplicate = true;
                existingEventId = messageValue.event.event.UID;
                existingParentEvent = await isEventExist(user.name.toString(), messageValue.event.event.UID, account);
            }

            if (params?.singleEvent) {
                isDuplicate = false;
                const existingEvent = await isEventExist(user.name.toString(), params?.uid, account);
                if (existingEvent) {
                    isDuplicate = true;
                    existingEventId = params?.uid;
                }
            }


            if (isDuplicate) {
                try {
                    const getEvent = await isEventExist(user?.name?.toString(), existingEventId, account);
                    const organizerValue = params.list.filter(data => {
                        return data.key === "organizer"
                    }).map(data => data.value)
                    const shareCalendarparams = {
                        events: [{
                            uid: params?.uid,
                            fromTime: params?.fromTime,
                            toTime: params?.toTime,
                            repeatEvent: `${repeatEvents}`,
                            customRepeatEvent: `${customRepeat}`,
                            singleEvent: `${singleEvent}`
                        }],
                        active: user?.name,
                        type: "update",
                    }
                    const eventParamsValue = {
                        uuid: getEvent?.[0]?.uuid?.toString(),
                        uid: params?.uid,
                        title: params?.title,
                        fromTime: params?.fromTime || "",
                        toTime: params?.toTime || "",
                    }
                    await updateEvent(token, shareCalendarparams)
                    const res = user.name.split("@")[0] + "@" + config.DOMAIN;
                    await encrypt([params], token, [getEvent[0].uuid]);
                    const hash = await transactionAction(contractInstance, 'editEvent', [[existingEventId], eventParamsValue, user.name.toString()], user.wallet, "calendar");
                    const convertedSubject = await getEmailContents(selectedMessage.subject, acceptValue);
                    if (hash && (organizerValue[0] !== user.name && organizerValue[0] !== res)) {
                        const result = await sendEmails([toOrFromName], [], [], convertedSubject, htmlContent, false, 'MSG', [icsFile], event)
                        if (result) {
                            toast.success("Event updated successfully", {
                                position: "top-center",
                                transition: Bounce,
                            });
                        } else {
                            toast.error("Faild to invite the guests", {
                                position: "top-center",
                                transition: Bounce,
                            });
                        }
                    } else {
                        if (hash) {
                            toast.success("Event updated successfully", {
                                position: "top-center",
                                transition: Bounce,
                            });
                        } else {
                            toast.error("Faild to update a event", {
                                position: "top-center",
                                transition: Bounce,
                            });
                        }
                    }

                } catch (error) {
                    const errorStr = toErrorString(error || error.message);
                    reportError({
                        endpoint: '/updateevents',
                        message: `FileName: Decrypt.js, Fun: handleEventdata, ${String(error.message || 'Unhandled error')}`,
                        error: errorStr,
                        userName: userName || '',
                    });
                    setDisabledButton();
                    console.error("Error updating event:", error);
                    toast.error(`Failed to update event: ${error.message}`, {
                        position: "top-center",
                        transition: Bounce,
                    });
                }
            } else {
                try {
                    const inputcontact = { contact: [] }
                    const organizerValue = params.list.filter(data => {
                        return data.key === "organizer"
                    }).map(data => data.value)
                    const shareCalendarparams = {
                        events: [{
                            uid: params?.uid,
                            fromTime: params?.fromTime,
                            toTime: params?.toTime,
                            repeatEvent: `${repeatEvents}`,
                            customRepeatEvent: `${customRepeat}`,
                            singleEvent: `${singleEvent}`
                        }],
                        active: user?.name,
                        type: "update",
                    }
                    await updateEvent(token, shareCalendarparams)
                    const encryptionValue = await encrypt([params], token, []);
                    const eventParamsValue = {
                        uuid: encryptionValue.data.encryptedData[0],
                        uid: params?.uid,
                        title: params?.title,
                        fromTime: params?.fromTime || "",
                        toTime: params?.toTime || "",
                    }
                    const paramsValue = [[eventParamsValue], user.name, inputcontact];
                    const hash = await transactionAction(contractInstance, "addEvent", paramsValue, user.wallet, "calendar")
                    if (hash) {
                        if (params?.singleEvent && existingParentEvent) {
                            const listings = [
                                ...(existingParentEvent?.list || []),
                                { key: 'singleEvent', value: params?.recurrence_id }
                            ].map(({ key, value }) => ({ key, value }));

                            existingParentEvent.list = listings;
                            const updatedEventObject = Object.fromEntries(
                                Object.entries(existingParentEvent)
                                    .filter(([key]) => isNaN(Number(key)) && key !== '__length__')
                            );
                            const response = await contractInstance.methods.getEncryptedValue(user.name.toString()).call();
                            const shareCalendarparams = {
                                events: [{
                                    uid: params?.uid,
                                    fromTime: params?.fromTime,
                                    toTime: params?.toTime,
                                    repeatEvent: `${repeatEvents}`,
                                    customRepeatEvent: `${customRepeat}`,
                                    singleEvent: `${singleEvent}`
                                }],
                                active: user?.name,
                                type: "update",
                            }
                            const encryptedUidValue = response.filter(data => {
                                return data.uid === messageValue.event.event.UID
                            })
                            await encrypt([params], token, [encryptedUidValue?.uuid]);
                            await updateEvent(token, shareCalendarparams)
                            const hash = await transactionAction(contractInstance, 'editEvent', [[messageValue?.event?.event?.UID], updatedEventObject, user.name.toString()], user.wallet, "calendar");
                        }

                        if (params?.appointmentEvent && messageValue?.event?.event?.STATUS === 'REQUEST') {
                            await sendConfirmationEmail(params?.uid)
                        }

                        const convertedSubject = await getEmailContents(selectedMessage.subject, acceptValue);
                        const res = user.name.split("@")[0] + "@" + config.DOMAIN;
                        if (hash && (organizerValue[0] !== user.name && organizerValue[0] !== res)) {
                            const result = await sendEmails([toOrFromName], [], [], convertedSubject, htmlContent, false, 'MSG', [icsFile], event);
                            if (result) {
                                toast.success("Event added successfully", {
                                    position: "top-center",
                                    transition: Bounce,
                                });
                            } else {
                                toast.error("Failed to invite the guests", {
                                    position: "top-center",
                                    transition: Bounce,
                                });
                            }
                        }
                        else {
                            toast.success("Event added successfully", {
                                position: "top-center",
                                transition: Bounce,
                            });
                        }

                    } else {
                        toast.error("Failed to added event", {
                            position: "top-center",
                            transition: Bounce,
                        });
                    }
                } catch (error) {
                    const errorStr = toErrorString(error || error.message);
                    reportError({
                        endpoint: '/updateevents',
                        message: `FileName: Decrypt.js, Fun: handleEventdata, ${String(error.message || 'Unhandled error')}`,
                        error: errorStr,
                        userName: userName || '',
                    });
                    setDisabledButton();
                    console.error("Error adding event:", error);
                    toast.error(`Failed to add event: ${error.message}`, {
                        position: "top-center",
                        transition: Bounce,
                    });
                }
            }
        } catch (error) {
            const errorStr = toErrorString(error || error.message);
            reportError({
                endpoint: '/updateevents',
                message: `FileName: Decrypt.js, Fun: handleEventdata, ${String(error.message || 'Unhandled error')}`,
                error: errorStr,
                userName: userName || '',
            });
            console.error(error)
        } finally {
            setLoader(false);
        }
    };

    // const handledelete = () => {};
    const toggleText = () => {
        setIsExpanded(!isExpanded);
    };

    useEffect(() => {
        web3AccountCheck(setWeb3, setAccount);
    }, []);
    useEffect(() => {
        setMessageList(props.messageList);
    }, [props.messageList]);

    useEffect(() => {
        if (!isOpenFileReader) {
            const model = document.querySelector(".ant-modal-wrap");
            if (model) {
                model.style.display = "none";
            }
        }
    }, [isOpenFileReader]);

    useEffect(() => {
        const value = JSON.parse(decryptedContent);
        const fetchIcons = async () => {
            const newIcons = {};
            // The same normalised list the strip renders — an icon map built from only the
            // singular key would come up empty for every message sent from the phone.
            for (const attachment of readAttachmentList(value)) {
                const type = Object.keys(attachment)?.[0];
                const icon = await getFileIcon(type);
                newIcons[type] = icon;
            }
            setIcons(newIcons);
        };

        fetchIcons();
        const prefersDarkScheme = window.matchMedia(
            "(prefers-color-scheme: dark)"
        ).matches;
        if (prefersDarkScheme) {
            document
                .querySelectorAll('.primary-text:not([class^="x_"])')
                .forEach((el) => {
                    el.style.setProperty("color", "#3c4043", "important");
                });
            document
                .querySelectorAll('.secondary-text:not([class^="x_"])')
                .forEach((el) => {
                    el.style.setProperty("color", "#70757a", "important");
                });
        }
    }, [props.decryptedContent]);

    const checkHeight = () => {
        if (messageContainerRef.current) {
            const container = messageContainerRef.current;
            if (container.scrollHeight > 225) {
                setShouldShowMoreButton(true);
                return true;
            } else {
                setShouldShowMoreButton(false);
                return false;
            }
        } else {
            setShouldShowMoreButton(false);
            return false;
        }
    };

    // Add resize event listener to check height when screen is resized
    useEffect(() => {
        const handleResize = () => {
            checkHeight();
        };

        // Check height initially
        checkHeight();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [htmlContent]); // Re-run when htmlContent changes

    useEffect(() => {

    }, [messageType])
    async function emailActionFunction(type) {

        await setMessageType(type);
        switch (type) {
            case "Reply":
            case "ReplyAll":
            case "Forward":
                setReplyModal(true);
                break;

            case "Starred": {
                setLoader(true);
                setText("Please wait, your changes are being stored on the blockchain, Going forward it will be fast.")
                try {
                    if (
                        selectedMessage &&
                        selectedMessage.id &&
                        (props.pageType === "Inbox" || props.pageType === "Important")
                    ) {
                        setLoader(true);
                        setText("Please wait, your changes are being stored on the blockchain, Going forward it will be fast.")
                        const contractMethods = getHostContract();
                        const response = selectedMessage?.isStarred === true;
                        await markMessageAsImportant(contractMethods, user.name, [selectedMessage.id], response, account);
                        setText("")
                        setLoader(false);
                        props.reRender();
                    } else if (
                        selectedMessage &&
                        selectedMessage.id &&
                        props.pageType === "Insecure"
                    ) {
                        await updateInsecureMail("fav", [selectedMessage.id], "");
                        props.reRender();
                    }
                } catch (error) {
                    const errorStr = toErrorString(error || error.message);
                    reportError({
                        endpoint: '-',
                        message: `FileName: Decrypt.js, Fun: emailActionFunction, ${String(error.message || 'Unhandled error')}`,
                        error: errorStr,
                        userName: userName || '',
                    });
                    console.error(error)
                } finally {
                    setLoader(false);
                    setText("")
                }
                break;
            }

            default:
                break;
        }
    }

    const renderTime = (time) => {
        const formattedDate = moment.tz(time, moment.tz.guess()).format('ddd MMM DD YYYY hh:mm A');
        return formattedDate;
    }
    const content = () => {
        return <div>
            <div>
                <table className="w-100 table table-collapse table-bottom-border">
                    <tbody>
                        <tr>
                            <th className="th-table-flex-end">from:</th>
                            <td>{senderDetails.sender}</td>
                        </tr>
                        <tr>
                            {senderDetails.to && <>
                                <th className="th-table-flex-end">to:</th>
                                <td>
                                    <ul className="ul-no-padding">
                                        {senderDetails.to?.map((data, index) => (
                                            <li key={index} className="list-unstyled">
                                                {data}
                                            </li>
                                        ))}
                                    </ul>
                                </td>
                            </>}

                        </tr>
                        <tr>
                            {senderDetails.subject && <>
                                <th className="th-table-flex-end">subject:</th>
                                <td className="fixed-width-break">{selectedMessage.subject}</td>
                            </>}
                        </tr>
                        {senderDetails.cc.length > 0 && senderDetails.cc[0].length > 0 && <tr>
                            <th className="th-table-flex-end">cc:</th>
                            <td>
                                <ul className="ul-no-padding">
                                    {senderDetails.cc.map((data, index) => (
                                        <li key={index} className="list-unstyled">
                                            {data}
                                        </li>
                                    ))}
                                </ul>
                            </td>
                        </tr>}
                        {senderDetails.bcc.length > 0 && senderDetails.bcc[0].length > 0 ? (
                            <tr>
                                <th className="th-table-flex-end">bcc:</th>
                                <td>
                                    <ul className="ul-no-padding">
                                        {senderDetails.bcc.map((data, index) => (
                                            <li key={index} className="list-unstyled">
                                                {data}
                                            </li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        ) : (
                            (() => {
                                const currentUser = localStorage.getItem('UserName');
                                if (!currentUser) return null;
                                
                                const user = currentUser.toLowerCase();
                                const isInTo = senderDetails.to?.some(to => to && to.toLowerCase().includes(user));
                                const isInCc = senderDetails.cc?.some(cc => cc && cc.toLowerCase().includes(user));
                                const isSender = senderDetails.sender?.toLowerCase().includes(user);
                                
                                if (!isInTo && !isInCc && !isSender) {
                                     return (
                                        <tr>
                                            <th className="th-table-flex-end">bcc:</th>
                                            <td>
                                                <ul className="ul-no-padding">
                                                    <li className="list-unstyled">
                                                        {currentUser}
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                     );
                                }
                                return null;
                            })()
                        )}
                        <tr>
                            <th className="th-table-date-flex-end">date:</th>
                            <td>{renderTime(selectedMessage.date)}</td>
                        </tr>
                        <tr>
                            <th className="th-table-date-flex-end">mailed-by:</th>
                            <td>{senderDetails.sender.split("@")[1]}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    }
    function processHtmlContent(htmlContent) {
        if (!htmlContent) return "";
        
        // Sanitize HTML to prevent XSS attacks
        const sanitizedHTML = DOMPurify.sanitize(htmlContent, {
            ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'a', 'img', 'div', 'span', 'table', 'tr', 'td', 'th', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'tbody', 'thead', 'tfoot', 'caption', 'col', 'colgroup', 'b', 'i', 's', 'strike', 'font', 'center', 'blockquote', 'pre', 'code', 'hr', 'sub', 'sup', 'small', 'big', 'tt', 'del', 'ins', 'mark', 'abbr', 'cite', 'q', 'dfn', 'kbd', 'samp', 'var', 'address', 'dl', 'dt', 'dd'],
            ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'style', 'class', 'id', 'target', 'rel', 'width', 'height', 'border', 'cellpadding', 'cellspacing', 'align', 'valign', 'bgcolor', 'color', 'size', 'face', 'colspan', 'rowspan'],
            ALLOW_DATA_ATTR: false,
            ADD_ATTR: ['target', 'rel']
        });
        
        const div = document.createElement("div");
        div.innerHTML = sanitizedHTML;
        const links = div.querySelectorAll("a");
        links.forEach((link) => {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "noopener noreferrer");
        });
        return div.innerHTML;
    }

    // ICS invites are attacker-shaped input: every one of these properties is OPTIONAL in the calendar data
    // we parse, and the `messageValue?.event &&` guard on the invite card below only proves `event` exists —
    // not `event.event`, not DTSTART, not ATTENDEES. Reading them raw in render meant one invite with no
    // ATTENDEE lines (or a VEVENT with no DTSTART) threw during render and, before the ErrorBoundary, blanked
    // the whole app. Derive everything defensively ONCE here and let the JSX read only these.
    const eventDetails = messageValue?.event?.event;
    const eventStartRaw = eventDetails?.DTSTART?.value || eventDetails?.DTSTART;
    const eventStartLocal = eventStartRaw
        ? convertToLocalDate(convertToUtc(eventStartRaw, eventTimeZone))
        : "";
    const eventStartParts = (eventStartLocal || "").split(/[\s,]/);
    const eventStartDay = eventStartParts[1] || "";
    const eventStartWeekday = eventStartParts[0] || "";
    // ATTENDEES is an array when present, but absent invites give undefined — and `{list.length && ...}`
    // would also render a bare "0" on an empty list, so count first and test with a comparison.
    const eventAttendees = eventDetails?.ATTENDEES;
    const eventAttendeeCount = Array.isArray(eventAttendees)
        ? eventAttendees.length
        : (eventAttendees?.length || 0);

    return (
        <div className="encrypted-message-parent-ele">
            <div className="encrypted-message-header-ele">
                <div className="topic-ele">
                    <p> Topic :</p>
                    <h2> {selectedMessage.subject} </h2>
                </div>

                <div className="actions cursor-pointer">
                    <Tooltip title="Starred" placement="top">
                        <div onClick={() =>
                            emailActionFunction("Starred")}>{starSvg}</div>
                    </Tooltip>
                    <Tooltip title="Reply all">
                        <div onClick={() => emailActionFunction("ReplyAll")}>{logo.reply_all_svg}</div>
                    </Tooltip>
                    <Tooltip title="Reply">
                        <div onClick={() => emailActionFunction("Reply")}>{logo.reply_svg}</div>
                    </Tooltip>
                    <Tooltip title="Forward">
                        <div onClick={() => emailActionFunction("Forward")}>{logo.forward_svg}</div>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <div
                            className="cursor-pointer"
                            onClick={async () => {
                                Swal.fire({
                                    text: "Are you sure you want to delete?",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#1677ff",
                                    cancelButtonColor: "#7f7f7f",
                                    confirmButtonText: "Yes",
                                    cancelButtonText: "No",
                                    customClass: "compose-sweet-alert",
                                }).then(async (result) => {
                                    if (result.isConfirmed) {
                                        setLoader(true);
                                        setText("Please wait, your email is being deleted, Going forward it will be fast.")
                                        if (props.pageType !== "Insecure") {

                                            const folderIndex = getFolderIndex;
                                            await deleteEmails(selectedMessage, selectedMessage.id, props.selectedIndex, messageList, props.pageType, folderIndex);

                                        }
                                        else {
                                            const value = [{
                                                id: selectedMessage.id,
                                                value: 1
                                            }]
                                            await updateInsecureMail(
                                                "bulkdelete",
                                                "",
                                                value
                                            );
                                        }
                                        props.reRender();
                                        props.setSelectedMessageIndex(null);
                                        setLoader(false);
                                        setText("")
                                    }
                                });
                            }}
                        >
                            {logo.msg_delete_icon}
                        </div>
                    </Tooltip>
                </div>
            </div >

            <div className="encrypted-message-header-ele" >
                <div className="topic-ele">
                    <p>{toOrFrom}</p>
                    <div className="user-details-section child-ele-encrypt">
                        <div className="user-profile-pic">
                            {getFirstLetterUppercase(toOrFromName)}
                        </div>
                        <div className="user-profile-name">
                            <div className="user-profile-username from-name">
                                {toOrFromName?.split("@")[0]}
                            </div>
                            <div className="flex-text-small">
                                <span>{props.pageType !== "Sent" ? `to ${senderDetails?.to?.join(', ')} ` : "to"}</span>
                                {senderDetails.to && props.pageType === "Sent" && senderDetails.to.map((data, index) => {
                                    if (index < 2) {
                                        return (
                                            <div>
                                                <span>{", "}{data}</span>
                                            </div>
                                        )
                                    }
                                })}
                                <Popover content={content} placement="bottom">
                                    <Button className="p-0 border-0"><CaretDownOutlined /></Button>
                                </Popover>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="actions date-encrypt">
                    <h4>
                        {props.pageType === "Insecure"
                            ? convertToLocalDateforWeb2(selectedMessage.date)
                            : convertToLocalDate(selectedMessage.date)}
                    </h4>
                    <div> {logo.key_unlock_svg} </div>
                </div>
            </div>

            <div className="encrypted-msg-content decrypt">
                <div className="class-msg-component-render decrypt-msg">
                    {messageValue?.event && (
                        <div className="row border radius-4px">
                            <div
                                className="col-sm-2 d-flex justify-content-center align-items-center event-date flex-col"
                            >
                                <div className="cal-icon-view">
                                    <div className="calender-svg-icon">
                                        <svg width="75" height="75" viewBox="0 0 20 20" className=" w-full items-center justify-center">
                                            <defs>
                                                <linearGradient
                                                    id="gradientText"
                                                    x1="0%"
                                                    y1="0%"
                                                    x2="100%"
                                                    y2="100%"
                                                >
                                                    <stop offset="0%" stopColor="#18F06E" />
                                                    <stop offset="100%" stopColor="#18F06E" />
                                                </linearGradient>
                                            </defs>
                                            <path
                                                d="M18 3.496h-3.001v-.46a1 1 0 10-2 0v.46h-6v-.46a1 1 0 10-1.999 0v.46H2c-.633 0-1 .359-1 1v11.5c0 .641.367 1 1 1h16c.633 0 1-.359 1-1v-11.5c0-.641-.367-1-1-1z"
                                                fill="#ffffff"
                                            />
                                            <text
                                                x="50%"
                                                y="50%"
                                                dominantBaseline="middle"
                                                textAnchor="middle"
                                                fill="url(#gradientText)"
                                                fontWeight="bold"
                                                fontSize="4"
                                                dy=".3em"
                                            >
                                                {eventStartDay}
                                            </text>
                                        </svg>
                                    </div>
                                    <div className="text-light d-flex w-full align-items-center justify-content-center">
                                        {eventStartWeekday}
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm pt-2">
                                <p className="my-auto font-size-15 fw-bold">
                                    {eventDetails?.SUMMARY?.value || eventDetails?.SUMMARY}
                                </p>
                                <div className="row d-flex justify-content-center align-items-center mt-2">
                                    <div className="col-sm-1 w-auto">{logo.time_svg}</div>
                                    <div className="col-sm">
                                        <p
                                            className="my-auto font-size-11 fill-979ea8"
                                        >
                                            When
                                        </p>
                                        <p className="my-auto fw-bold font-size-13">
                                            {fromstart} - {toend}
                                        </p>
                                    </div>
                                </div>
                                {eventAttendeeCount > 0 && (
                                    <div className="row d-flex justify-content-center align-items-center mt-2">
                                        <div className="col-sm-1 w-auto">{logo.people_svg}</div>
                                        <div className="col-sm">
                                            <p className="my-auto font-size-11 fill-979ea8">
                                                Who
                                            </p>
                                            <p className="my-auto fw-bold font-size-13">
                                                {`${eventAttendeeCount} guests invited`}
                                            </p>
                                        </div>
                                    </div>
                                )}

                                <div className="col-sm border-top d-flex gap-1 mt-2 mb-1">
                                    <span
                                        className="my-auto font-size-11 fill-979ea8"

                                    >
                                        Are you going?
                                    </span>

                                    {(eventDetails?.STATUS === "CANCELLED" || messageValue.event.method === "CANCEL") ? (<>
                                        <div
                                            className="btn-group btn-group-toggle border mt-1 ml-2"
                                            data-toggle="buttons"
                                        >
                                            <button disabled={disable}
                                                className="btn btn-light deleteEvent"
                                                onClick={() => { deleteevent(messageValue.event) }}

                                            >Update a calendar</button>
                                        </div>

                                    </>) : (<div
                                        className="btn-group btn-group-toggle border mt-1 ml-2"
                                        data-toggle="buttons"
                                    >
                                        <button
                                            className="btn btn-light"
                                            onClick={async () => {
                                                setLoader(true);
                                                setText("Please wait, your changes are being stored on the blockchain, Going forward it will be fast.")
                                                handleButtonClick(1);
                                                await handleEventdata('accept');
                                                setLoader(false);
                                                setText("")
                                            }}
                                            disabled={disabledButton === 1}
                                        >
                                            Yes
                                        </button>
                                        <button
                                            className="btn btn-light border-left-dee2e6"
                                            onClick={async () => {
                                                setLoader(true);
                                                setText("Please wait, your changes are being stored on the blockchain, Going forward it will be fast.")
                                                handleButtonClick(2);
                                                await handleEventdata('maybe');
                                                setLoader(false);
                                                setText("")
                                            }}
                                            disabled={disabledButton === 2}
                                        >
                                            Maybe
                                        </button>
                                        <button
                                            className="btn btn-light border-left-dee2e6"
                                            onClick={async () => {
                                                setLoader(true);
                                                setText("Please wait, your changes are being stored on the blockchain, Going forward it will be fast.")
                                                handleButtonClick(3);
                                                await handleEventdata('no');
                                                setLoader(false);
                                                setText("")
                                            }}
                                            disabled={disabledButton === 3}
                                        >
                                            No
                                        </button>
                                    </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    <div>
                        <div
                            className={
                                isExpanded ? "email-contents mt-2 " : "email-contents truncated-text mt-2"
                            }
                            ref={messageContainerRef}
                            dangerouslySetInnerHTML={{
                                __html: htmlContent ? processHtmlContent(htmlContent) : "",
                            }}
                        />
                        {shouldShowMoreButton && (
                            <Tooltip title={isExpanded ? "Show less" : "Show more"}>
                                <button
                                    className="message_show_more_button cursor-pointer"
                                    onClick={toggleText}
                                >
                                    {logo.show_more_svg}
                                </button>
                            </Tooltip>
                        )}
                    </div>

                    {attachmentValue?.length > 0 && (
                        <div className="attachment-msg-section">
                            {attachmentValue.map((attachment, index) => (
                                <div
                                    className="attachment-div-element d-flex-data "
                                    key={index}
                                    onMouseEnter={() => setHoveredIndex(index)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                    onClick={async () => {
                                        try {
                                            setLoader(true);
                                            setText("Please wait, your attachement is being decrypted, Going forward it will be fast.")
                                            const decryptedFile = await getFile(
                                                Object.keys(attachment)[0],
                                                attachment[Object.keys(attachment)[0]]
                                            );
                                            setDecryptFile(decryptedFile);
                                            setIsOpenFileReader(true);
                                            setLoader(false);
                                            setText("")
                                        } catch (e) {
                                            const errorStr = toErrorString(e || e.message);
                                            reportError({
                                                endpoint: '-',
                                                message: String(e.message || 'Unhandled error'),
                                                error: errorStr,
                                                userName: userName || '',
                                            });
                                            console.error("Error getting file:", e);
                                            setLoader(false);
                                            setText("")
                                        }
                                    }}
                                >
                                    <span className="file-name-preview text-center">
                                        {Object.keys(attachment)?.[0]}
                                    </span>


                                    {hoveredIndex !== index && (
                                        audioExtensions.includes(Object.keys(attachment)?.[0]?.split(".")?.[1]) ? (
                                            <div className="attachment-icon">
                                                <FileAudio2 width={70} height={70} strokeWidth="1px" />
                                            </div>
                                        ) : videoExtensions.includes(Object.keys(attachment)?.[0]?.split(".")?.[1]) ? (
                                            <div className="attachment-icon">
                                                <FileVideo2 width={70} height={70} strokeWidth="1px" />
                                            </div>
                                        ) : (
                                            <div className="attachment-icon">
                                                {icons[Object.keys(attachment)?.[0]] || ""}
                                            </div>
                                        )
                                    )}
                                    {hoveredIndex === index && (
                                        <>
                                            <div className="attachment-actions">
                                                <Tooltip title="Download">
                                                    <div
                                                        onClick={async (e) => {
                                                            e.stopPropagation();
                                                            setLoader(true);
                                                            setText("Please wait, your attachment is being downloaded, Going forward it will be fast.")
                                                            await downloadFile(
                                                                Object.keys(attachment)[0],
                                                                attachment[Object.keys(attachment)[0]]
                                                            );
                                                            setLoader(false);
                                                            setText("")
                                                        }}
                                                    >
                                                        {logo.download_svg_attachment}
                                                    </div>
                                                </Tooltip>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <CompleteLoader isOpen={loader} text={text} />
                <ReplyModal isModalOpen={replyModal} close={handleCloseModal} attachmentValue={attachmentValue} msg={selectedMessage} decryptedMessage={htmlContent} messageType={messageType} pageType={props.pageType} />
                {isOpenFileReader && (
                    <FileReaderModel isOpen={isOpenFileReader} file={decryptFile} close={() => { setDecryptFile(null); setIsOpenFileReader(false); }} />
                )}
            </div>
        </div >
    );
};

export default Decrypt;
